import React, { forwardRef } from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import categoryLeadersSVG from 'assets/category-leaders.svg'

import classes from './LeaderBadge.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const LeaderBadge = forwardRef(({ href, onClick = noop, ...props }, ref) => {
  return (
    <a
      ref={ref}
      onClick={onClick}
      href={href}
      className={clsx('LeaderBadge', classes.root)}
      role="button"
      data-testid="leader-badge"
      {...props}
    >
      <img src={categoryLeadersSVG.src} alt="Category Leaders" width={93} height={9} />
      <Icon icon={['ga', 'category-leaders-gem']} size={12} className={classes.icon} />
    </a>
  )
})

export default LeaderBadge
